import React, { useState } from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { Account } from './Account';
import { NotificationBell } from '../Notifications';
import { LogoLink } from './Header.styles';
import { useAuth } from '../../_auth/useAuth';
import SidebarNav from './SidebarNav';
import { NavMenu } from './NavMenu'; // Correct named import


export const Header: React.FC = () => {
    const theme = useTheme();
     const { isAuthenticated, canNavigateState } = useAuth()
      const [sidebarOpen, setSidebarOpen] = useState(false);
    return (
        <AppBar sx={{ backgroundColor: theme.daPalette.black.main }}>
            <Toolbar variant="dense" sx={{ display: 'flex', alignItems: 'center', px: 2, minHeight: 56, width: '100%', minWidth: 0, overflowX: 'hidden' }}>
                {/* Mobile/tablet menu button left (hidden when nav is disabled, e.g. /company/register) */}
                {canNavigateState && (
                <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', flex: '0 0 auto', minWidth: 0 }}>
                    <IconButton
                        color="inherit"
                        aria-label="Open navigation menu"
                        onClick={() => setSidebarOpen(true)}
                        edge="start"
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                </Box>
                )}
                {/* Desktop: logo left, nav center, bell/account right */}
                <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', width: '100%' }}>
                    <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', minWidth: 0 }}>
                        <LogoLink key="logoHome" to="/">
                            <img src={require("../../../static/img/da_paf_manager_logo_256x32.png")} alt="PAF Manager - Data Axle" style={{ maxHeight: 32 }} />
                        </LogoLink>
                    </Box>
                    <Box sx={{ flex: '1 1 0', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 0 }}>
                        <NavMenu />
                    </Box>
                    <Box sx={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'flex-end', minWidth: 0 }}>
                        {isAuthenticated && canNavigateState && <NotificationBell />}
                        {canNavigateState && <Account />}
                    </Box>
                </Box>
                {/* Mobile/tablet: bell/account right only (logo removed; hidden when nav disabled, e.g. /company/register) */}
                <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1, flex: 1, justifyContent: 'flex-end', minWidth: 0 }}>
                    {isAuthenticated && canNavigateState && <NotificationBell />}
                    {canNavigateState && <Account />}
                </Box>
            </Toolbar>
            {/* Sidebar for mobile/tablet */}
            <SidebarNav open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        </AppBar>
    );
};


